import script from "./CredentialsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CredentialsModal.vue?vue&type=script&setup=true&lang=js"

import "./CredentialsModal.vue?vue&type=style&index=0&id=164ee650&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164ee650"]])

export default __exports__